import entityContainerConnector from '~components/generic/entityContainerConnector';
import { ColorMain } from '~modules/palette/ColorMain';

export default entityContainerConnector(ColorMain);
